import { state, mutations } from './mutations';
import * as getters from './getter';

export default {
  name: 'wordbank',
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Wordbank/_store/index.js